module.exports = __webpack_public_path__ + "static/media/logo141.46206266.png";